var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter",class:{
    'is-deactive': !_vm.activeFilter,
    'is-verydeactive-lol': _vm.status === 'inactive',
    'is-act': _vm.status === 'active',
    'is-partial': _vm.status === 'partial'
  },attrs:{"type":"button","name":"button"},on:{"click":_vm.filter}},[_c('span',{staticClass:"filter-text"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('i',{staticClass:"filter-check"})])}
var staticRenderFns = []
export { render, staticRenderFns }